import React, { useState } from 'react';
import { Grid, Icon, Header, Form, Loader } from 'semantic-ui-react';

import { useDispatch, useSelector } from 'react-redux';


import Phone from './Phone';
import contactDuplicatesActions from 'actions/contact_duplicates';
import { useFieldArray } from 'react-hook-form';
import { PhoneUtil, RecordUtils, StringUtils } from 'utils';
import RecordPhonesForm from 'shared/forms/RecordPhonesForm';
import PHONE_TYPE_OPTIONS from 'shared/constants/PHONE_TYPE_OPTIONS';
import { ActivityPopup } from 'shared/forms/NewActivity';
import PHONE_ICON from 'shared/constants/PHONE_ICON';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const PhoneRenderer = ({ phone, isPhoneSystemSupported, onPhoneClick, areOtherPhonesShown, nonMainPhones, setPhoneBeingLoggedForActivity, contact_id, phoneBeingLoggedForActivity }) => (
    <div
        onClick={() => {
            if (!isPhoneSystemSupported) return;
            onPhoneClick({ phone: phone.phone });
        }}
        style={
            areOtherPhonesShown && nonMainPhones.length > 0
                ? { marginBottom: 10 }
                : {}
        }
    >
        {isPhoneSystemSupported ? (
            <Phone phone={phone.phone} phone_type={phone.phone_type} />
        ) : (
            <ActivityPopup
                trigger={
                    <div>
                        <Icon
                            name={
                                PHONE_ICON[
                                    StringUtils.capitalize(
                                        phone?.phone_type
                                    )
                                ] || "phone"
                            }
                        />
                        <p className="ContactInfo__contact">
                            {PhoneUtil.formatPhoneNumber(phone?.phone)}
                        </p>
                    </div>
                }
                activityProps={{
                    hideActivitySelection: true,
                    isContact: true,
                    contact: { id: contact_id }
                }}
                open={phoneBeingLoggedForActivity === phone?.phone}
                onOpen={() => setPhoneBeingLoggedForActivity(phone?.phone)}
                onClose={() => setPhoneBeingLoggedForActivity(null)}
            />
        )}
    </div>
);


const PhonesField = ({
    contact_id,
    account_id,
    
    shouldCheckDuplicates = true,
    noPadding,
    allowNoPhones,

    isEditing,

    control,
    watchedPhones,
    setError,
    clearErrors,
    isUpdating,
    onPhoneClick
}) => {
    const dispatch = useDispatch();

    const {
        mainPhones,
        nonMainPhones,
        isReadingPhones,
        userPhoneCreds
    } = useSelector((state) => {
        const phones = state.contact_phone.phone ? state.contact_phone.phone.slice(0) : [];
        const mainPhones = phones.filter(phone => phone.main);
        const nonMainPhones = phones.filter(phone => !phone.main);
        return {
            mainPhones,
            nonMainPhones,
            isReadingPhones: state.contact_phone.isReadingPhones,
            userPhoneCreds: state.officeView.creds
        }
    })
    const isPhoneSystemSupported =
                PhoneUtil.isPhoneSystemSupported(userPhoneCreds);

    const [areOtherPhonesShown, setOtherPhonesShown] = useState(false);
    const [phoneBeingLoggedForActivity, setPhoneBeingLoggedForActivity] = useState();

    const onToggleOtherPhones = () => {
        setOtherPhonesShown(!areOtherPhonesShown);
    }

    const { fields: phonesToEdit, append: addPhone, remove: removePhone, update: updatePhone } = useFieldArray({
        control,
        name: 'phones'
    });

    const checkDuplicates = (queryParameters) => {
        return dispatch(contactDuplicatesActions.checkDuplicates(queryParameters));
    }

    if (isReadingPhones) {
        return <Loader active />
    }

    const renderedPhoneProps = { phoneBeingLoggedForActivity, areOtherPhonesShown, isPhoneSystemSupported, contact_id, nonMainPhones, onPhoneClick, setPhoneBeingLoggedForActivity };

    return (
        !isEditing ? (
            <Grid.Row verticalAlign='top' className={`ContactInfo__phoneValue ${noPadding ? 'ContactInfo__row' : ''}`}>
                <Grid.Column width={9} style={{ paddingRight: 0, flex: 1 }}>
                    <div >
                        {mainPhones.length <= 0 && (
                            <span>
                                <Icon name='fas fa-phone' size='small' /> No main phone
                            </span>
                        )}
                        {mainPhones.map((phone) => <PhoneRenderer {...renderedPhoneProps} key={phone?.id} phone={phone}/>)}
                        {areOtherPhonesShown && (
                            <div>
                                {nonMainPhones.map(phone => (
                                    <PhoneRenderer {...renderedPhoneProps} key={phone?.id} phone={phone}/>
                                ))}
                            </div>
                        )}
                    </div>
                </Grid.Column>
                <Grid.Column width={1} style={{ left: -15 }}>
                    {nonMainPhones.length > 0 && <Icon disabled={nonMainPhones.length <= 0} onClick={onToggleOtherPhones} bordered size='tiny' name={`caret ${areOtherPhonesShown ? 'down' : 'right'}`} link style={{ marginLeft: 5, fontSize: 9, borderRadius: 5 }} />}
                </Grid.Column>
            </Grid.Row>
        ) : (
            <Grid.Row>
                <Grid.Column>
                    <Form size='mini' loading={isUpdating}>
                        <Header size='small' color='primary'>
                            <span>
                                <RestrictedView type="disabled" userPermission={account_id ? USER_PERMISSIONS.ACCOUNT_ADD : USER_PERMISSIONS.CONTACTS_ADD}>
                                    <Icon link onClick={() => { PhoneUtil.onAddPhone({ value: '', type: PHONE_TYPE_OPTIONS.keys.CELL, new: true }, phonesToEdit, addPhone) }} className='fas fa-plus-circle' color='primary' /> Phones
                                </RestrictedView>
                            </span>
                        </Header>
                        <RecordPhonesForm
                            control={control}
                            phones={phonesToEdit}
                            onRemove={(index) => {
                                RecordUtils.removeItem(watchedPhones, index, updatePhone, removePhone);
                            }}
                            updateMain={(onChange) => {
                                RecordUtils.updateMain(watchedPhones, updatePhone, onChange);
                            }}
                            checkDuplicates={shouldCheckDuplicates ? checkDuplicates : () => { return [] }}
                            clearErrors={clearErrors}
                            contact_id={contact_id}
                            setError={setError}
                            allowNoPhones={allowNoPhones}
                            isForContact={true}
                        />
                    </Form>
                </Grid.Column>
            </Grid.Row>
        )
    );
};

export default PhonesField;
